<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      width="960"
    >
        <template v-slot:activator="{ props }">
            <a class="btn ml-12 mt-0" v-bind="props" style="cursor: pointer;" >{{$t("message.applynow")}}</a>
      </template>
      <v-card class="rounded-0">
        <v-card-title class="mt-5" >
            <div class="d-flex justify-space-between mb-4">
                <h4 style="padding-bottom:0px !important;">{{$t('message.applynow')}}</h4>
                <button><Icon icon="fluent-mdl2:cancel" height="15px" @click="dialog = false"/></button>
            </div>
        </v-card-title>
        <v-card-text class="px-0 py-0">

      <v-expansion-panels variant="accordion" v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-title style="background-color: #d8d8d9" class="rounded-0">
            {{$t("message.perFileUpload")}}
            <template v-slot:actions="{ expanded }">
                <span :style="expanded ? '' : 'transform: rotate(45deg)' ">
                    <Icon icon="fluent-mdl2:cancel" height="15px"/>
                </span>
            </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text style="background-color: #d8d8d9">
            <form class="form__row" @submit.prevent="sendApplication('Upload')"><!---->
        <v-row>
            <v-col cols="12" md="6">
                    <select name="gender" id="gender" v-model="request.gender" style="width: 100%" :placeholder="$t('message.pleaseSelect')">
                        <option value="" disabled selected>{{$t("message.pleaseSelect")}}</option>
                        <option value="female" >{{$t("message.female")}}</option>
                        <option value="male">{{$t("message.male")}}</option>
                        <option value="-">-</option>
                    </select>
                    <v-row>
                        <v-col><input type="text" name="firstname" class="form__row" v-model="request.firstname" :placeholder="$t('message.firstname')"   required/></v-col>
                        <v-col><input type="text" name="lastname"  class="form__row" v-model="request.lastname"  :placeholder="$t('message.lastname')"   required/></v-col>
                    </v-row>
                    <input type="mail"  name="email"  class="form__row" v-model="request.email"     :placeholder="$t('message.email')"   required/>
                    <input type="text"  name="phone" class="form__row" v-model="request.phone"     :placeholder="$t('message.phone')" required/>
            </v-col>
            <v-col cols="12" md="6">
                <div class="fileInputWrapper d-flex justify-content-center align-center" style="margin-top:24px">
                  <div style="width: 100%">
                    <p class="text-center" style="width:100%">{{$t("message.dragDropFiles")}}</p>
                    <button style="width:100%" class="px-3 py-1 text-center"><span style="background-color: #999;color: #ffffff" class="py-1 px-3">{{$t("message.chooseFiles")}}</span></button>
                  </div>
                    
                    <input @change="uploadFile" class="fileInput" type="file" name="files[]" ref="fileff" accept=".pdf,.zip, .rar, .doc, .docx, .jpg, .jpeg, .png, .gif" multiple/><br>
                    <!-- <input class="fileInput"  type="file" name="files[]" ref="fileff" v-on:change="onChangeFileUpload()" accept=".pdf,.zip, .rar, .doc, .docx, .jpg, .jpeg, .png, .gif" multiple/><br> -->
                </div>
                <p class="my-2 text-left">{{$t("message.acceptedFiles")}}</p>
                <p class="text-left" v-for="file of uploadedFiles" :key="file">{{file.name}} {{(file.size / 1024).toFixed(0) + " kB" }} <Icon @click="dropFile(file)" icon="ic:baseline-delete" /></p>
                <v-sheet v-if="showMsgFileCount" class="d-flex justify-content-center" width="100%" style="border: 1px solid red"><p class="py-3 px-3">{{$t("message.maxCounfOfFilesPassed")}}</p></v-sheet>            
              </v-col>
        </v-row>
          <button class="btn mt-9 sticky-right mb-3" id="btnSendApplication" type="submit"  style="margin-bottom:0px;">{{$t("message.sendApplication")}}</button>              
          <!-- <button class="btn mt-9 sticky-right mb-3" id="btnSendApplication" type="submit" @click="sendApplication('Upload')"  style="margin-bottom:0px;">{{$t("message.sendApplication")}}</button>               -->
            <v-progress-circular
              v-if="sendOnProgress"
              indeterminate
              color="red"
              :size="20"
              :width="3"
            ></v-progress-circular> 
            <span v-if="sendSuccessfully"> {{$t("message.applicationSentSuccessfully")}}</span>
        </form>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
        </v-card-text>
      </v-card>
      
    </v-dialog>
  </v-row>
</template>

<script>
import { Icon } from '@iconify/vue';

  export default {
    data: () => ({
      dialog: false,
      request:{
        gender: "",
        firstname: "",
        lastname: "",
        link: "",
        email: "",
        phone: "",
        files: [],
      },        
      uploadedFiles: {},
      panel: [0],
      showMsgFileCount: false,
      sendOnProgress: false,
      sendSuccessfully: false,
    }),
    components: {
        Icon,
    },
    props: {
      job: {
        type: Object,
      },
    },
    methods: {

      uploadFile(file) {
        if(file.target.files.length > 5){
          this.showMsgFileCount = true;
          return;
        }
        this.showMsgFileCount = false;
        this.uploadedFiles = file.target.files;
      },
      dropFile(file){
        let filesArr = [...this.uploadedFiles];
        this.uploadedFiles = filesArr.filter(elm => elm.name != file.name);
      },
      async sendApplication(channel){
        this.sendOnProgress = true;
        this.request.files = this.uploadedFiles;

        var formData = new FormData();
        formData.append('gender', this.request.gender);
        formData.append('firstname', this.request.firstname);
        formData.append('lastname', this.request.lastname);
        formData.append('link', this.request.link);
        formData.append('email', this.request.email);
        formData.append('phone', this.request.phone);

        if (this.$refs.fileff.files.length > 0) {
          let filenames = [];
          for (let i = 0; i < this.$refs.fileff.files.length; i++) {
            let file = this.$refs.fileff.files[i];
            filenames.push(this.$refs.fileff.files[i]['name']);
            formData.append('file' + i, file);
          }
          formData.append('filenames', filenames);
        }

        formData.append('job_id', this.job.id);
        formData.append('job_title', this.job.title);
        formData.append('department', this.job.department);
        formData.append('description', this.job.description);
        formData.append('channel', channel);
        formData.append('recruiter', this.job.recruiter);
        formData.append('zoho_id', this.job.zoho_id);
        
        await axios({
            method: 'post',
            withCredentials: true,
            data: formData,
            url: 'https://jobs.loxone.com/wp-content/loxone/jobs-api/index.php?action=sendApplication',
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        }).then(resp => {
          if(resp.data === true) {
            console.log("response received successfully");
          }else{
            // console.log(resp);                
            this.sendOnProgress = false;
            this.sendSuccessfully = true;
            setTimeout(() => {
                this.dialog  = false;
                this.request = {
                gender: "",
                firstname: "",
                lastname: "",
                link: "",
                email: "",
                phone: "",
                files: [],
                };
                this.uploadedFiles= {};
                this.sendSuccessfully = false;
              }, 3000);
          }        
        });
      }
    },
  }
</script>

<style scoped>
    .v-expansion-panel-title {
        height: 100px !important;
    }
    .form__row input,
      .form__row select,
    .form__row textarea {
        width: 100%;
        line-height: 40px;
        min-height: 48px;
        padding: 0 10px;
        box-sizing: border-box;
        font-size: 16px;
        border-radius: 0;
        border: 1px solid #c4c4c4;
        background-color: white;
        margin-top: 1.5em;

    }

    .form__row select:focus-visible,
    .form__row input:focus-visible,
    .form__row textarea:focus-visible {
        border: 1px solid #69c350;
        outline: none;
    }

    .fileInputWrapper {
      height: 150px;
      width: 100%;
      position: relative;
      cursor: pointer;
      background-color: #ffffff;
      border: 2px dotted #aeaeae
  }
  .fileInput {
      cursor: pointer;
      height: 100%;
      width: 100%;
      position:absolute;
      top: 0;
      right: 0;
      z-index: 99; 
      font-size:50px;
      opacity: 0;
      -moz-opacity: 0;
  }
</style>